<template>
  <div
    class="loader"
    v-if="isLoading">
    <div class="loader-spinner"></div>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
};
</script>
